import { ApolloError } from '@apollo/client'

export const formatGraphqlError = (error: ApolloError) => {
  if (error.graphQLErrors[0]?.extensions?.code)
    return {
      extra: {},
      error: error.graphQLErrors[0].message,
      errorCode: error.graphQLErrors[0].extensions?.code as string
    }
  else if (error.graphQLErrors[0]?.extensions?.exception)
    return error.graphQLErrors[0].extensions?.exception.response
  else
    return {
      extra: {},
      error: 'Error inesperado',
      errorCode: 'UNEXPECTED_ERROR'
    }
}

export const formatErrorEnums = Object.freeze({
  // ------------------------------- F ----------------------------
  FAILED_TO_UPDATE_ARTICLES: {
    detail: 'Error al actualizar algunos artículos'
  },
  // ------------------------------- G ----------------------------
  GUESTPOSTING_NOT_FOUND: {
    detail: 'Campaña no encontrada en esta organización.'
  },
  GUESTPOSTING_IS_NOT_PUBLISHED: {
    detail: 'La campaña no ha sido publicada aún'
  },
  GUESTPOSTING_INVOICE_INVALID: {
    detail:
      'El estado de la factura relacionado con el guest posting no es válido, comuníquese con soporte'
  },
  // ------------------------------- I ----------------------------
  INVOICE_PENDING: { detail: 'La factura está pendiente de pago' },
  INVALID_CREDENTIALS: { detail: 'Usuario o contraseña incorrectos' },
  // ------------------------------- K ----------------------------
  KEYWORD_ALREADY_EXISTS: { detail: 'Este keyword ya existe' },
  // ------------------------------- M ----------------------------
  MAX_DRAFT_CAMPAIGNS_REACHED: {
    detail:
      'Ha alcanzado el numero maximo de campañas en borrador, publica alguna campaña para poder crear una nueva'
  },
  // ------------------------------- N ----------------------------
  NOT_ALLOW: { detail: 'Acción no permitida, rol o estado no válido' },
  NOT_ENOUGH_SITES: {
    detail: 'No hay suficientes sitios para el país seleccionado'
  },
  // ------------------------------- P ----------------------------
  PROJECT_NOT_FOUND: { detail: 'Proyecto no encontrado en esta organización.' },
  PROJECT_NOT_EMPTY: {
    detail: 'No se puede borrar un proyecto que no este vació.'
  },
  // ------------------------------- U ----------------------------
  USER_NOT_FOUND: { detail: 'Usuario no encontrado' },
  USER_NOT_VERIFIED: { detail: 'Usuario no verificado' },
  USER_ALREADY_REGISTERED: { detail: 'Usuario ya registrado' },
  // ------------------------------- L ----------------------------
  LANGUAGE_NOT_FOUND: { detail: 'Idioma no encontrado' }
})
